__turbopack_context__.v({
  "carousel": "Carousel-module-scss-module__yWOZXq__carousel",
  "mobile-peakaboo": "Carousel-module-scss-module__yWOZXq__mobile-peakaboo",
  "pagination": "Carousel-module-scss-module__yWOZXq__pagination",
  "pagination-container": "Carousel-module-scss-module__yWOZXq__pagination-container",
  "prev-next-control-container": "Carousel-module-scss-module__yWOZXq__prev-next-control-container",
  "prev-next-controls": "Carousel-module-scss-module__yWOZXq__prev-next-controls",
  "sized-slides": "Carousel-module-scss-module__yWOZXq__sized-slides",
  "slide": "Carousel-module-scss-module__yWOZXq__slide",
  "slide-container": "Carousel-module-scss-module__yWOZXq__slide-container",
  "slide-viewport": "Carousel-module-scss-module__yWOZXq__slide-viewport",
  "unsized-slides": "Carousel-module-scss-module__yWOZXq__unsized-slides",
});
